export default () => ({
  beforeCC: new Set(),
  configDef: new Map(),
  defProviders: new Map(),
  defValue: new Map(),
  excludeDef: new Set(),
  keepDef: new Set(),
  mockDef: new Set(),
  providerDef: new Map(),
  replaceDef: new Set(),
});
